<template>
  <div id="main">
      <div class="api_link">
          <span></span>
      </div>
      <div class="details_title select_company_title">{{title}}</div>
      <div class="company-box">
          <ul>
              <li v-for="(list,index) in companyList" :key="index" class="company_list" @click="orderList(list.companyId,list.companyName)">
                <!-- <img v-bind:src="list.companyLogo" alt=""> -->
                <div style="margin-left:40px;margin-right:40px;">
                  <svg width="60" height="60" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M95.1171 35.4668C96.2066 36.9379 97.1712 38.5049 98 40.15C97.7842 41.5361 97.2933 42.8602 96.5586 44.0377C96.0108 45.0734 93.8342 49.2013 92.0469 50.3721C87.4495 52.9072 82.6208 54.9588 77.6325 56.4963C75.2922 57.2313 73.1498 58.5267 71.3767 60.2789C69.3298 62.6506 48.3137 84.6258 48.3137 84.6258L45.0705 83.6501C45.0705 83.6501 50.5047 77.0305 48.8615 68.6397C48.1523 64.7669 46.4994 61.1488 44.0615 58.1324C47.345 63.7782 47.7754 70.7375 45.2146 76.7753C43.9265 79.4235 42.1483 81.7803 39.9822 83.7101C38.6417 84.8059 38.0363 84.8209 38.9011 85.0911L49.5101 88.3934C54.6128 89.8944 55.838 94.0973 55.6794 95.7635C55.6794 96.4239 55.2758 98 55.2758 98L33.6255 91.0052C33.6255 91.0052 18.9084 86.1718 18.1445 86.0968C16.3732 85.7825 14.9732 84.3604 14.6274 82.5243C14.6274 80.9032 14.7571 78.5015 14.267 77.5859C10.7505 73.826 7.4579 69.8458 4.40759 65.6676C0.89228 60.7887 -0.611973 54.6525 0.227426 48.6159C1.75535 37.8834 14.2238 29.2225 24.0399 30.9637C29.6471 31.9694 37.5894 34.341 62.4542 38.9042C62.179 34.7739 63.2785 30.6711 65.5677 27.2861C64.7461 26.1603 61.2434 23.2633 54.3966 24.5993C49.8249 25.4701 45.1665 25.7424 40.53 25.4098C35.2976 25.0946 17.2796 18.4 15.3913 17.8296C12.6958 17.049 14.4976 15.518 16.4147 14.6774C17.8807 14.0123 19.3823 13.436 20.912 12.9512C26.7759 15.9024 32.8359 18.4106 39.0453 20.4564C43.9983 21.6193 49.0975 21.9537 54.1515 21.4471C61.0704 20.9968 66.2452 22.6179 67.6001 24.6293C66.8506 23.3984 63.1605 20.0211 55.5641 20.1262C50.4987 20.2185 45.4425 19.6435 40.5155 18.415C37.2147 17.6345 29.6039 13.2965 23.5499 9.69396C19.4129 7.23226 15.9967 5.19085 15.2039 4.72553C12.8112 3.55472 14.267 2.90927 16.4436 2.3689C21.544 0.917342 26.7968 0.125835 32.0832 0.0122703C42.8939 -0.302948 53.5317 5.53609 59.6434 8.20794C65.7551 10.8798 79.6361 21.2369 79.6361 21.2369L80.2271 21.6722C82.3118 22.4915 84.3521 23.4285 86.3388 24.4792C90.2883 26.9709 95.1171 35.4668 95.1171 35.4668ZM25.3496 92.2141C25.9037 91.977 26.5252 91.977 27.0793 92.2141L32.4703 93.9866C32.4703 93.9866 27.0937 96.9909 25.4937 96.1797C24.7437 95.8473 24.2453 95.0934 24.2144 94.2446C24.1836 93.3958 24.6258 92.6047 25.3496 92.2141Z" fill="#0055FF"/>
                  </svg>
                </div>
                <p>{{list.companyName}}</p>
              </li>
          </ul>
      </div>
      <bottom></bottom>
      <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
  </div>
</template>

<script>
import logo from '../../assets/image/common/ExpiredLogo.png'
import px from '../../assets/image/selectcompany/4PX.png'
import dhl from '../../assets/image/selectcompany/DHL.png'
import royale from '../../assets/image/selectcompany/Royale.png'
import bottom from '../Bottom.vue'
export default {
  name: 'SelectCompany',
  components: {bottom},
  data () {
    return {
      title: null,
      companyList: [],
      action: null,
      allowAction: {'merchantTakeExpress': true, 'collectExpiredExpress': true, 'select': true}
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
    // 获取操作
    this.action = this.$route.query.action
    let action = this.action
    // 判断是否是允许的操作
    let res = this.actionList
    if (!res[action]) {
      alert('Unknown operation')
      // 未知的操作直接返回
      this.$router.push('/index')
      return false
    }
  },
  created () {
    this.action = this.$route.query.action
    let logisticType = null
    if (this.action === 'merchantTakeExpress') {
      this.title = this.$t('selectCompany.ReturnCourier')
      logisticType = 'COLLECT_RETURN'
    }
    if (this.action === 'collectExpiredExpress') {
      this.title = this.$t('selectCompany.ReturnExpired')
      logisticType = 'COLLECT_EXPIRED'
    }
    if (this.action === 'select') {
      let tag = this.$route.query.tag
      if (tag === 'courier') {
        this.title = 'Return to courier'
        logisticType = 'COLLECT_RETURN'
      }
      if (tag === 'expired') {
        this.title = 'Return expired'
        logisticType = 'COLLECT_EXPIRED'
      }
    }
    // 初始化注入&校验时请求页面数据
    const vue = this
    this.axios({
      method: 'GET',
      url: this.api.logistic,
      params: {
        type: logisticType
      }
    }).then(function (response) {
      console.log(vue.action)
      if (vue.action === 'select') {
        let data = response.data
        let name = vue.$route.query.cname
        for (let i = 0; i < response.data.length; i++) {
          if (data[i]['companyName'] === name) {
            vue.companyList.push(data[i])
          } else {
            continue
          }
        }
      } else {
        vue.companyList = response.data
      }
      vue.getLogo()
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getLogo () {
      const vue = this
      // const imgUrl = 'http://ppb.f3322.net:10084/api/file/v1/preview/'
      // const imgUrl = 'https://alfred-uat-api.pakpobox.com/api/file/v1/preview/'
      // const imgUrl = 'https://alfredhk.pakpobox.com/api/file/v1/preview/'
      // const imgUrl = process.env.VUE_APP_IMG_BASE_PATH
      const imgUrl = window.config.VUE_APP_IMG_BASE_PATH
      $.each(this.companyList, function (index, value) {
        if (value.companyLogo) {
          vue.companyList[index].companyLogo = imgUrl + value.companyLogo
        } else {
          vue.companyList[index].companyLogo = logo
        }
      })
    },
    orderList (id, name) {
      if (this.action === 'select') {
        let tag = this.$route.query.tag
        let action = ''
        if (tag === 'courier') {
          action = 'merchantTakeExpress'
        }
        if (tag === 'expired') {
          action = 'collectExpiredExpress'
        }
        this.$router.push('/barcode?action=' + action + '&logisticsId=' + id)
      } else {
        this.$router.push('/return/expired?action=' + this.action + '&id=' + id + '&name=' + name)
      }
    }
  }
}
</script>

<style lang="less" src="../../assets/css/order/selectcompany.css" scoped>

</style>
<style scoped>
    .details_bt_w{
        /* position: fixed; */
        position: sticky;
        width: 83%;
        bottom: 0.38rem;
    }
    .company-box{
        min-height: calc(70vh);
    }

    .bottom{
        /*position: relative;*/
        /*bottom: 0;*/
    }

    .select_company_title{
      color: var(--primary-text-color);
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/SelectCompany.vue